import React, {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Mui
import {
  Box,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  Tooltip,
} from "@mui/material";

//Img
import brokenImg from "../../assets/png/brokenImg.png";

import styles from "./GuestClusterListPage.module.css";

// Jds
import {
  ActionButton,
  AvatarV2,
  Button,
  Container,
  DropdownMenuGroup,
  DropdownMenuItem,
  Icon,
  InputCheckbox,
  Notifications,
  Spinner,
  Text,
} from "@jds/core";

import EmptyState from "../../components/NoData/EmptyState";
import FsLightbox from "fslightbox-react";
import {
  addParamsURL,
  downloadFile,
  getFileNameFromDisposition,
} from "../../util/helper";
import decryptUrl from "../../util/img-decryption";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { VirtuosoGrid } from "react-virtuoso";
import JdsModal from "../../components/UI/JdsModal";
import JdsMenu from "../../components/UI/JdsMenu";
import { FileUploadContext } from "../../components/Layout/FileUploadLayout";
import useApiHttp from "../../hooks/use-http";
import Loader from "../../components/UI/Loader/Loader";
import PageLoader from "../../components/UI/Loader/PageLoader";
const gridComponents = {
  List: forwardRef(({ style, children, ...props }, ref) => (
    <div
      ref={ref}
      {...props}
      style={{
        display: "flex",
        flexWrap: "wrap",
        ...style,
      }}>
      {children}
    </div>
  )),
  Item: ({ children, ...props }) => (
    <div
      {...props}
      style={{
        padding: "0.5rem",
        width: "200px",
        display: "flex",
        flex: "none",
        alignContent: "stretch",
        boxSizing: "border-box",
      }}>
      {children}
    </div>
  ),
};

const getPhotoMediaId = (photo) => photo?.mediaId ?? photo?.id;
const hasPhotoMediaId = (mediaId) => mediaId != null;
const hasValidClusterId = (clusterId) =>
  clusterId !== null && clusterId !== undefined && Number(clusterId) !== 0;
const getProfileClusterId = (profile) => {
  if (hasValidClusterId(profile?.clusterId)) return profile.clusterId;
  if (hasValidClusterId(profile?.mergeClusterId)) return profile.mergeClusterId;
  return profile?.clusterId ?? profile?.mergeClusterId;
};
const isSameId = (first, second) =>
  first !== null &&
  first !== undefined &&
  second !== null &&
  second !== undefined &&
  String(first) === String(second);
const getProfileDisplayName = (profile) =>
  (
    profile?.username ||
    profile?.profileName ||
    `${profile?.firstName || ""} ${profile?.lastName || ""}`
  )
    .trim()
    .toLowerCase();

export default function GuestClusterListPage({ }) {
  const { id: eventId, gid: guestId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { handleFileDownloadOP } = useContext(FileUploadContext);
  // const { firstName, lastName } = location.state || {};
  const {
    firstName,
    lastName,
    indexedProfileThumbnail,
    indexedProfilePic,
    user,
    secondaryProfilesCount,
    selectedSecondaryProfile,
    selectedSecondaryProfileId,
    selectedSecondaryClusterId,
  } = location.state || {};
  console.log(indexedProfileThumbnail);

  const [faceList, setGuestClusterList] = useState([]);
  const [faceCount, setFaceCount] = useState(0);
  const [previewImgArr, setPreviewImgArr] = useState([]);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [check, setCheck] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [preview, setPreview] = useState(null);
  const [primaryProfile, setPrimaryProfile] = useState([]);
  const [secondaryProfileList, setSecondaryProfileList] = useState([]);
  const [selectedProfileDetails, setSelectedProfileDetails] = useState(
    selectedSecondaryProfile || {},
  );
  const [isPrimaryProfileSelected, setIsPrimaryProfileSelected] =
    useState(!selectedSecondaryProfile && selectedSecondaryClusterId == null);
  const [selectedClusterId, setSelectedClusterId] = useState(
    hasValidClusterId(selectedSecondaryClusterId)
      ? selectedSecondaryClusterId
      : null,
  );

  const { sendRequest: getGuestCluster, isLoading: isGetGuestClusterLoading } =
    useApiHttp();
  const { sendRequest: deleteImgReq, isLoading: deleteImgReqing } =
    useApiHttp();
  const { sendRequest: downloadRequest, isLoading: imageIsDownloading } =
    useApiHttp();
  const {
    sendRequest: getSecondaryProfiles,
    isLoading: secondaryProfilesLoading,
  } = useApiHttp();

  const openLightboxOnSlide = (number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  };

  const handleSelectAllChange = (checked) => {
    setSelectAll(checked); // Update checkboxes state
    setCheck((prev) => Array(prev.length).fill(checked));

    // Update selected IDs
    if (checked) {
      const ids = faceList.map(getPhotoMediaId).filter(hasPhotoMediaId);
      setSelectedId(ids);
    } else {
      setSelectedId([]);
    }
  };

  const handleCheckboxChange = useCallback((checked, index, mediaId) => {
    setCheck((prev) => {
      const newCheck = [...prev];
      newCheck[index] = checked; // Update the checkbox state
      return newCheck; // Return the new array
    });
    if (checked) {
      setSelectedId((pre) => [...pre, mediaId]);
    } else {
      setSelectedId((pre) => pre.filter((item) => item !== mediaId));
      setSelectAll(false);
    }
  }, []);

  const deleteImage = () => {
    const deleteIds = selectedId;
    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("mediaIDs", deleteIds);
    deleteImgReq(
      {
        url: `image/delete`,
        method: "DELETE",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "delete-photos",
          tilte: data.message,
        });
        const fLength = faceList.length;
        setCheck(Array(fLength - deleteIds.length).fill(false));
        setGuestClusterList((pre) =>
          pre.filter((item) => !deleteIds.includes(getPhotoMediaId(item))),
        );
        setFaceCount((pre) => pre - deleteIds.length);
        setSelectedId([]);
        if (selectAll) {
          if (page == 0) {
            getGuestClusterHandler(0, guestId);
          } else {
            setPage(0);
          }
        }
      },
      (err, data) =>
        Notifications.toast.error({ id: "delete-photos", tilte: data.message }),
    );
  };
  const getGuestClusterHandler = (
    page,
    clusterId,
    isPrimaryProfileSelected = true,
  ) => {
    if (page == 0) {
      setGuestClusterList([]);
      setSelectAll(false);
      setCheck([]);
      setSelectedId([]);
    }

    if (!isPrimaryProfileSelected && !hasValidClusterId(clusterId)) {
      setFaceCount(0);
      setLastPage(0);
      setGuestClusterList([]);
      setPreviewImgArr([]);
      setCheck([]);
      setSelectedId([]);
      return;
    }

    getGuestCluster(
      {
        url: isPrimaryProfileSelected
          ? `face/organizer-user-photos?eventId=${eventId}&guestId=${guestId}&page=${page}&size=50`
          : `face/cluster-images?eventId=${eventId}&clusterId=${clusterId}&page=${page}&size=50`,
        base: "MEDIA",
      },
      null,
      (data) => {
        setFaceCount(data?.count);
        setLastPage(data?.lastPage);
        if (page == 0) {
          setGuestClusterList(data?.data);
          setPreviewImgArr(
            data?.data?.map((item, i) => (
              <img
                src={addParamsURL(decryptUrl(item?.reducedFileSignedPath), {
                  size: "m",
                })}
                style={{ width: "100%", height: "100%" }}
              />
            )),
          );
          setCheck(Array(data?.data.length).fill(false));
        } else {
          setGuestClusterList((prev) => [...prev, ...data?.data]);
          setPreviewImgArr((pre) => [
            ...pre,
            ...data?.data?.map((item, i) => (
              <img
                src={addParamsURL(decryptUrl(item?.reducedFileSignedPath), {
                  size: "m",
                })}
                style={{ width: "100%", height: "100%" }}
              />
            )),
          ]);
          if (selectAll) {
            setCheck((pre) => [...pre, ...Array(data?.data.length).fill(true)]);
            const ids = data?.data?.map(getPhotoMediaId).filter(hasPhotoMediaId);
            setSelectedId((pre) => [...pre, ...ids]);
          } else {
            setCheck((pre) => [
              ...pre,
              ...Array(data?.data.length).fill(false),
            ]);
          }
        }
      },
      (err, data) => {
        if (!isPrimaryProfileSelected && data?.statusCode === 404) {
          setFaceCount(0);
          setLastPage(0);
          setGuestClusterList([]);
          setPreviewImgArr([]);
          setCheck([]);
          setSelectedId([]);
          return;
        }

        Notifications.toast.error({
          id: "guest-cluster-list-error",
          title: data?.message || "Something went wrong",
        });
      },
    );
  };

  const downloadHandle = (mediaId) => {
    downloadRequest(
      {
        url: `organizer/download`,
        method: "POST",
        base: "MEDIA",
        body: {
          mediaId,
          eventId,
        },
      },
      null,
      (data, res) => {
        const imageUrl = URL.createObjectURL(data);
        const fileName = getFileNameFromDisposition(res);
        downloadFile(imageUrl, fileName);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "download-photos-error",
          title: data?.message,
        });
      },
    );
  };

  const getSecondaryProfilesHandler = () => {
    getSecondaryProfiles(
      {
        url: `face/guest/profile/cluster?eventId=${eventId}&userId=${guestId}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        const primaryProfiles = data?.data?.primary || [];
        const secondaryProfiles = data?.data?.secondary || [];
        const selectedSecondary = secondaryProfiles.find(
          (profile) =>
            isSameId(profile?.secondaryProfileId, selectedSecondaryProfileId) ||
            isSameId(profile?.profileId, selectedSecondaryProfileId) ||
            (selectedSecondaryProfile &&
              getProfileDisplayName(profile) ===
                getProfileDisplayName(selectedSecondaryProfile)) ||
            (hasValidClusterId(selectedSecondaryClusterId) &&
              isSameId(getProfileClusterId(profile), selectedSecondaryClusterId)),
        );

        setPrimaryProfile(primaryProfiles);
        setSecondaryProfileList(secondaryProfiles);

        if (selectedSecondary) {
          const selectedSecondaryResolvedClusterId =
            getProfileClusterId(selectedSecondary);

          setIsPrimaryProfileSelected(false);
          setSelectedClusterId(
            hasValidClusterId(selectedSecondaryResolvedClusterId)
              ? selectedSecondaryResolvedClusterId
              : null,
          );
          setSelectedProfileDetails({
            ...selectedSecondary,
            username:
              selectedSecondary?.username ||
              selectedSecondary?.profileName ||
              selectedSecondaryProfile?.username,
          });
          if (
            !isSameId(selectedClusterId, selectedSecondaryResolvedClusterId) ||
            isPrimaryProfileSelected
          ) {
            getGuestClusterHandler(0, selectedSecondaryResolvedClusterId, false);
          }
          return;
        }

        if (selectedSecondaryProfile) {
          setIsPrimaryProfileSelected(false);
          setSelectedProfileDetails(selectedSecondaryProfile);
          setSelectedClusterId(
            hasValidClusterId(selectedSecondaryClusterId)
              ? selectedSecondaryClusterId
              : null,
          );
          return;
        }

        setSelectedProfileDetails(primaryProfiles[0]);
      },
      (err, data) => {
        // Notifications.toast.error({
        //   id: "get-secondary-profile-for-user",
        //   title: data?.message,
        // });
      },
    );
  };

  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isGetGuestClusterLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isGetGuestClusterLoading, lastPage],
  );

  // Drowpdown menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (selectedId.length === faceList.length && selectedId.length !== 0) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedId]);

  useEffect(() => {
    getGuestClusterHandler(page, selectedClusterId, isPrimaryProfileSelected);
  }, [page]);

  useEffect(() => {
    getSecondaryProfilesHandler();
  }, []);

  return (
    <>
      <Container
        horizontalAlign="space-between"
        fullWidth
        style={{
          marginTop: "-32px",
          position: "sticky",
          top: "72px",
          backgroundColor: "white",
          padding: "32px 16px 16px",
          zIndex: 30,
          width: "calc(100% + 32px)",
          marginLeft: "-16px",
        }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            width: "100%",
          }}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            mb={2}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}>
              <Icon
                ic={"IcBack"}
                color="primary_60"
                onClick={() =>
                  user && user === "PG"
                    ? navigate(`/home/events/photographers/${eventId}`)
                    : navigate(-1)
                }
              />
              <Text
                text={user && user === "PG" ? "Photographer" : "Guest"}
                appearance="heading-xs"
              />
            </div>

            {/* Filter by face button */}
            {secondaryProfileList.length > 0 && (
              <Box>
                <Button
                  kind="tertiary"
                  label="Filter by Face"
                  icon={"IcChevronDown"}
                  onClick={handleMenuClick}
                />
                <Menu
                  id="face-filter-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    elevation: 4,
                    sx: {
                      ml: "-20px", // adjust spacing below the button/arrow
                    },
                  }}
                // sx={{
                //   '& p': {
                //     fontFamily: 'var(--font-families-body-s)',
                //     fontSize: 'var(--font-sizes-body-s)',
                //     fontWeight: 'var(--font-weights-body-s)',
                //     color: 'var(--color-primary-grey-100)',
                //     lineHeight: 'var(--line-heights-body-s)',
                //     letterSpacing: 'var(--letter-spacing-body-s)',
                //   }
                // }}
                >
                  {
                    <MenuItem
                      selected={isPrimaryProfileSelected && selectedClusterId == null}
                      onClick={() => {
                        handleClose();
                        setSelectedProfileDetails(primaryProfile[0]);
                        setIsPrimaryProfileSelected(true);
                        setSelectedClusterId(null);
                        getGuestClusterHandler(
                          page,
                          primaryProfile[0]?.userId,
                          true,
                        );
                      }}>
                      <Stack direction={"row"} alignItems={"center"} gap={1.5}>
                        <AvatarV2 size="medium" avatarKind={"icon"} />
                        <Box>
                          <Text
                            text={"All Profiles"}
                            appearance="body-s-bold"
                          />
                        </Box>
                      </Stack>
                    </MenuItem>
                  }
                  {primaryProfile.length > 0 && (
                    <MenuItem
                      selected={
                        selectedClusterId === primaryProfile[0]?.clusterId
                      }
                      onClick={() => {
                        handleClose();
                        setIsPrimaryProfileSelected(false);
                        setSelectedProfileDetails(primaryProfile[0]);
                        setSelectedClusterId(primaryProfile[0]?.clusterId);
                        getGuestClusterHandler(
                          page,
                          primaryProfile[0]?.clusterId,
                          false,
                        );
                      }}>
                      <Stack direction={"row"} alignItems={"center"} gap={1.5}>
                        <AvatarV2
                          size="medium"
                          avatarKind={
                            primaryProfile[0]?.mediaUrl ? "image" : "icon"
                          }
                          image={primaryProfile[0]?.mediaUrl}
                        />
                        <Box>
                          <Text
                            text={primaryProfile[0]?.username}
                            appearance="body-s-bold"
                          />
                          <Text
                            text={primaryProfile[0]?.profileType}
                            appearance="body-xxs"
                            color="feedback-success-50"
                          />
                        </Box>
                        {/* {selectedClusterId === primaryProfile[0]?.clusterId &&
                        <Box sx={{ height: '6px', aspectRatio: 1, borderRadius: '50%', backgroundColor: 'var(--color-primary-50)' }}></Box>
                      } */}
                      </Stack>
                    </MenuItem>
                  )}
                  {secondaryProfileList.map((data, i) => {
                    const profileClusterId = getProfileClusterId(data);

                    return (
                      <MenuItem
                        key={i}
                        selected={
                          isSameId(
                            selectedProfileDetails?.secondaryProfileId,
                            data?.secondaryProfileId,
                          ) ||
                          isSameId(selectedProfileDetails?.profileId, data?.profileId) ||
                          (hasValidClusterId(profileClusterId) &&
                            isSameId(selectedClusterId, profileClusterId))
                        }
                        onClick={() => {
                          handleClose();
                          setIsPrimaryProfileSelected(false);
                          setSelectedProfileDetails({
                            ...data,
                            username: data?.profileName,
                          });
                          setSelectedClusterId(
                            hasValidClusterId(profileClusterId)
                              ? profileClusterId
                              : null,
                          );
                          getGuestClusterHandler(0, profileClusterId, false);
                        }}>
                        <Stack
                          direction={"row"}
                          alignItems={"center"}
                          gap={1.5}>
                          <AvatarV2
                            size="medium"
                            avatarKind={data?.mediaUrl ? "image" : "icon"}
                            image={data?.mediaUrl}
                          />
                          <Box>
                            <Text
                              text={data?.username}
                              appearance="body-s-bold"
                            />
                            <Text
                              text={data?.profileName}
                              appearance="body-xxs"
                              color="primary-grey-80"
                            />
                          </Box>
                          {/* {selectedClusterId === data?.clusterId &&
                            <Box sx={{ height: '6px', aspectRatio: 1, borderRadius: '50%', backgroundColor: 'var(--color-primary-50)' }}></Box>
                          } */}
                        </Stack>
                      </MenuItem>
                    );
                  })}
                </Menu>
              </Box>
            )}
          </Stack>
          {page === 0 && isGetGuestClusterLoading ? (
            <Skeleton variant="text" sx={{ fontSize: "1rem", width: "100%" }} />
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                // justifyContent: "center",
                gap: "8px",
              }}>
              <AvatarV2
                size="xtra-large"
                avatarKind={
                  selectedProfileDetails?.mediaUrl || indexedProfileThumbnail
                    ? "image"
                    : "icon"
                }
                image={
                  selectedProfileDetails?.mediaUrl || indexedProfileThumbnail
                }
                onClick={() => {
                  // dispatch(setSelfieModalClose(false));
                  // navigate("/user-registered/profile-selfie");
                  setPreview(selectedProfileDetails?.mediaUrl || indexedProfilePic);
                }}
              />
              <Box>
                {/* <Text
                  text={`${firstName || "User"} ${lastName || ""
                    }  - ${faceCount} ${faceCount > 1 ? "Photos" : "Photo"}`}
                  appearance="body-m"
                  color="primary-grey-100"
                /> */}
                <Text
                  text={`${selectedProfileDetails?.username || firstName + " " + lastName} - ${faceCount} ${faceCount > 1 ? "Photos" : "Photo"}`}
                  appearance="body-m"
                  color="primary-grey-100"
                />

                {/* Secondary profile count and faces info */}
                {secondaryProfilesCount > 0 && isPrimaryProfileSelected && (
                  <Stack direction={"row"} alignItems={"center"} gap={1}>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      gap={"2px"}
                      mt={"2px"}>
                      <Icon ic={"IcProfile"} size="s" color="primary_grey_60" />
                      <Text
                        text={`${secondaryProfilesCount} secondary profile${secondaryProfilesCount > 1 ? "s" : ""}`}
                        color="primary_grey_80"
                      />
                    </Stack>
                    {secondaryProfileList.length === 0 && (
                      <Box
                        sx={{
                          "& .MuiChip-root": { backgroundColor: "#fff4e5" },
                          "& .j-JDSText-text ": { color: "#663c00" },
                        }}
                        mt={0.5}>
                        <Chip
                          label={
                            <Text
                              text="Faces not found"
                              appearance="body-xxs"
                            />
                          }
                          size="small"
                        />
                      </Box>
                    )}
                  </Stack>
                )}
              </Box>
            </div>
          )}
          {preview && (
            <ImagePreviewModal
              imageUrl={preview}
              onClose={() => setPreview(null)}
            />
          )}

          {/* Faces section */}
          {/* <Stack mt={3} direction={'row'} alignItems={'center'}>
            <Box sx={{ borderRadius: '16px', border: '1px solid var(--color-primary-grey-60)' }} p={2}>
              <AvatarV2
                size="xtra-large"
                avatarKind={indexedProfileThumbnail ? "image" : "icon"}
                image={indexedProfileThumbnail}
                onClick={() => {

                }}
              />
            </Box>
          </Stack> */}

          {/* <Stack mt={3} gap={1}>
            <Text text="Secondary Profiles" appearance="body-m" />
            <Stack direction={'row'} alignItems={'center'}>
              <AvatarV2
                size="xtra-xtra-large"
                avatarKind={indexedProfileThumbnail ? "image" : "icon"}
                image={indexedProfileThumbnail}
                onClick={() => {

                }}
              />
            </Stack>
          </Stack> */}
        </div>
      </Container>
      {selectedId.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#f5f5f5",
            padding: "4px 16px",
            borderRadius: "24px",
            "--color-primary-60": "#444746",
            marginBottom: "8px",
          }}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
            }}>
            <Box
              sx={{
                "--color-primary-grey-60": "#444746",
                cursor: "pointer",
              }}
              title="Clear selection"
              onClick={() => {
                setSelectedId([]);
                setCheck((pre) => Array(pre.length).fill(false));
              }}>
              <Icon ic={"IcCloseRemove"} color="grey-60" size="m" />
            </Box>
            <ActionButton
              label={`Selected ${selectedId.length}`}
              icon={"IcImage"}
              kind="secondary"
              size="small"
            />

            <ActionButton
              icon={selectAll ? "IcCheckboxOn" : "IcCheckboxIndeterminate"}
              label="Select"
              size="small"
              kind="secondary"
              onClick={() => {
                handleSelectAllChange(!selectAll);
              }}
            />
            <ActionButton
              icon={"IcDownload"}
              label="Download"
              size="small"
              kind="secondary"
              onClick={() => {
                if (selectedId.length > 1) {
                  handleFileDownloadOP(selectedId, eventId);
                }
                if (selectedId.length == 1) {
                  downloadHandle(...selectedId);
                }
              }}
            />
            <JdsMenu
              trigger={{
                component: MenuButton,
                componentProps: {
                  style: {
                    marginTop: "3px",
                  },
                },
              }}>
              <DropdownMenuGroup hideBottomDivider>
                <DropdownMenuItem
                  prefix={"IcTrash"}
                  label="Delete"
                  value="delete"
                  onClick={() => {
                    setDeleteModalClose(false);
                  }}
                />

                {/* <DropdownMenuItem prefix={"IcShare"} label="Share" value="share" /> */}
              </DropdownMenuGroup>
            </JdsMenu>
          </div>
          <div>
            <Tooltip
              title="You can delete up to 50 photos at a time from an album"
              placement="bottom"
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#fff", // Custom background
                    fontSize: "16px", // Font size
                    padding: "2px 6px",
                    borderRadius: "4px",
                    fontWeight: "700",
                    color: "#444746",
                  },
                },
              }}>
              <Box
                sx={{
                  "--color-primary-grey-60": "#444746",
                }}>
                <Icon ic={"IcInfo"} color="grey-60" size="m" />
              </Box>
            </Tooltip>
          </div>
        </div>
      )}
      {faceList.length !== 0 && (
        <VirtuosoGrid
          style={{
            height:
              selectedId.length > 0
                ? "calc(100vh - 306px)"
                : "calc(100vh - 250px)",
          }}
          className="custom-scrollbar"
          data={faceList}
          components={gridComponents}
          itemContent={(i, photo) => (
            <PhotoCard
              photo={photo}
              openLightboxOnSlide={openLightboxOnSlide}
              lastElementRef={i + 1 === faceList.length ? lastElementRef : null}
              index={i}
              check={check[i]}
              handleCheckboxChange={handleCheckboxChange}
            />
          )}
        />
      )}
      {isGetGuestClusterLoading && page !== 0 && (
        <Loader size="small" containerProps={{ style: { height: "100%" } }} />
      )}
      {faceList.length === 0 && !isGetGuestClusterLoading && (
        <Container fullWidth horizontalAlign="center">
          <EmptyState title="No images found." action={false} />
        </Container>
      )}
      {page === 0 && isGetGuestClusterLoading && (
        <Container
          fullWidth
          horizontalAlign="center"
          verticalAlign="center"
          style={{ minHeight: "220px" }}>
          <Spinner kind="primary" label="Loading..." size="large" />
        </Container>
      )}

      {deleteImgReqing && (
        <PageLoader
          open={deleteImgReqing}
          label={deleteImgReqing && "Please wait for a while..."}
        />
      )}

      <JdsModal
        size="m"
        kind="custom"
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        headerProps={{ divider: "false" }}>
        <div>
          <Stack gap={0.5}>
            <Text
              text={
                selectedId.length > 50
                  ? `You can delete a maximum of 50 images at a time.`
                  : `You have selected ${selectedId.length} image(s) to delete.`
              }
              appearance="heading_xs"
            />
            <Text
              text={
                selectedId.length > 50
                  ? `Deselect some images to continue.`
                  : `These items will get permanently deleted from PhotoShare.`
              }
              appearance="body_s"
              color="primary-grey-80"
            />
          </Stack>
          <Stack
            direction={"row"}
            justifyContent={"end"}
            gap={"12px"}
            mt={"8px"}>
            {selectedId.length > 50 ? (
              <ActionButton
                label="Ok"
                kind="primary"
                size="medium"
                onClick={() => {
                  setDeleteModalClose(true);
                }}
                appearance=""
              />
            ) : (
              <>
                {" "}
                <ActionButton
                  label="Cancel"
                  kind="secondary"
                  size="medium"
                  onClick={() => {
                    setDeleteModalClose(true);
                  }}
                  appearance=""
                />
                <ActionButton
                  label="Delete"
                  kind="primary"
                  size="medium"
                  onClick={() => {
                    deleteImage();
                    setDeleteModalClose(true);
                  }}
                  appearance=""
                  state={deleteImgReqing ? "loading" : "normal"}
                />
              </>
            )}
          </Stack>
        </div>
      </JdsModal>

      {previewImgArr.length ? (
        <FsLightbox
          disableLocalStorage={true}
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
          onClose={() => { }}
        />
      ) : null}
    </>
  );
}

const MenuButton = (props) => {
  return (
    <ActionButton
      icon={"IcMoreVertical"}
      kind="tertiary"
      size="medium"
      {...props}
    />
  );
};

const PhotoCard = ({
  photo = {},
  lastElementRef = null,
  openLightboxOnSlide = () => { },
  index = 0,
  check = false,
  handleCheckboxChange = () => { },
}) => {
  const [errorImg, setErrorImg] = useState(false);

  return (
    <div
      className="photos-card"
      key={index}
      style={{
        position: "relative",

        width: "184px",
        height: "184px",
        margin: "8px",
      }}
      onClick={() => {
        openLightboxOnSlide(index + 1);
      }}
      ref={lastElementRef}>
      <div className="frame-container">
        <LazyLoadImage
          alt="face"
          effect="blur"
          src={
            errorImg
              ? brokenImg
              : addParamsURL(decryptUrl(photo?.thumbnailFileSignedPath), {
                size: "s",
                width: 500,
                height: 500,
              })
          }
          placeholderSrc={addParamsURL(
            decryptUrl(photo?.thumbnailFileSignedPath),
            {
              size: "s",
              width: 500,
              height: 500,
            },
          )}
          style={{
            objectFit: "cover",
            // width: "162px",
            // height: "162px",
            width: "100%",
            height: "100%",
            aspectRatio: 1,
            borderRadius: "24px",
          }}
          onError={() => {
            setErrorImg(true);
          }}
        />
      </div>
      <div
        className={`card-select-overlay ${check ? "card-select-overlay-view" : ""
          }`}
        onClick={() => {
          // openLightboxOnSlide(index + 1);
        }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            marginTop: "15px",
            padding: "0 15px",
          }}>
          <div></div>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}>
            <InputCheckbox
              checked={check}
              onChange={(e) => {
                handleCheckboxChange(e.target.checked, index, getPhotoMediaId(photo));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const ImagePreviewModal = ({ imageUrl, onClose }) => {
  const handleClickOutside = (e) => {
    if (e.target.classList.contains(styles.overlay)) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleClickOutside}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <img src={imageUrl} alt="Preview" className={styles.image} />
      </div>
    </div>
  );
};
